export default {
  APP_LINK_REGISTER: {
    META: { TITLE: 'Postúlate ahora' },
    INTRO_SCREEN: {
      DESCRIPTION: '{{company}} realiza su proceso de selección para la vacante de <strong>{{jobOffer}}</strong> a través de la app de wokap.',
      BUTTON: 'Iniciar proceso',
    },
    ACCESS_REGISTER_SCREEN: {
      MESSAGE_1: 'Para participar en la vacante de [oferta], debes:',
      MESSAGE_2: 'Grabar tu video de presentación y subir tu CV en la app de wokap.\nDe lo contrario, [empresa] no podrá ver tu perfil ni evaluar tu candidatura.\n',
    },
    INITIAL_REGISTER_SCREEN: {
      MESSAGE_1: 'Para participar en la vacante de {{jobOffer}}, debes:',
      MESSAGE_2: 'Grabar tu video de presentación y subir tu CV en la app de wokap.',
      DESCRIPTION: 'De lo contrario, <strong>{{company}}</strong> no podrá ver tu perfil ni evaluar tu candidatura.',
    },
    FORM_EMAIL: {
      TITLE: 'Correo electrónico',
      EMAIL: 'Escribe tu correo electrónico',
      DATA_PROCESSING: 'Confirmo que he leído, entendido y acepto los',
      DATA_PROCESSING_LINK: 'Términos y Condiciones',
      DATA_PROCESSING_DESCRIPTION_1: ', el',
      DATA_PROCESSING_LINK_2: 'Aviso de Privacidad',
      DATA_PROCESSING_DESCRIPTION_2: ', el uso de cookies y tecnologías similares, así como el tratamiento y análisis de mi actividad dentro de wokap conforme a sus políticas.',
      SHOW_OFFER: 'Ver oferta',
    },
    FORM_PERSONAL_INFO: {
      TITLE: 'Datos personales',
      DESCRIPTION: 'Completa tus datos:',
      NAME: 'Nombre',
      LASTNAME: 'Apellidos',
      PHONE: 'WhatsApp',
      SHOW_OFFER: 'Ver oferta',
      UPLOAD_CV: 'Subir CV (PDF)',
      REPLACE: 'Reemplazar CV (PDF)',
      FILE: 'Archivo actual:',
      UPLOAD_CV_SIZE_ERROR: 'El tamaño del archivo excede el límite permitido de',
    },
    FINAL_FORM: {
      TITLE: 'Último paso',
      DESCRIPTION_1: 'Tu registro aún no está completo.',
      DESCRIPTION_2: 'Graba tu video de presentación y sube tu CV en la app de wokap.',
      DESCRIPTION_3: 'De lo contrario, {{company}} no podrá considerarte para la vacante.',
      DESCRIPTION_4: 'Descarga la app de wokap y sigue las instrucciones.',
      DESCRIPTION_5: 'Al registrarte, usa tu correo electrónico: <strong>{{userEmail}}</strong>',
      DESCRIPTION_6: '<span class="download-link-text">Descarga la app</span> 👇🏽',
      PC_WARNING: '* Si estás usando una computadora, cambia a tu teléfono para descargar<br class="hidden sm:block">la app de wokap y desde ahí continuar tu proceso en la vacante.',
    },
    FORM: {
      TITLE: 'Inscríbete a la oferta de <strong>{{company}}</strong>',
      DESCRIPTION: 'Introduce tu Email para poder acceder a la Oferta.',
      EMAIL: 'Email de contacto',
      SUBMIT: 'Me interesa',
      SHOW_OFFER: 'Ver oferta',
    },
    MODAL: {
      TITLE: 'Oferta de empleo',
      REQUIREMENT_MINIMUM: 'Requisitos Mínimos',
      REQUIREMENT_DESIRED: 'Requisitos Deseados',
      SHARE_TEXT: '¡Mira esta oferta de trabajo que acabo de encontrar!\n{{jobTitle}}',
    },
    FINALIZE: {
      TITLE: 'Descarga la app de <strong>wokap</strong> para postularte en <strong>{{company}}</strong>',
      DESCRIPTION: 'Al iniciar sesión en <strong>wokap</strong>, ingresa tu correo para acceder a esta oferta.',
      DESCRIPTION_1: 'Si ya tienes la app de <strong>wokap</strong> instalada, podrás acceder a la oferta desde las notificaciones.',
      DOWNLOAD_IOS: 'Descargar la app para iOS',
      DOWNLOAD_ANDROID: 'Descargar la app para Android',
      DOWNLOAD_OTHER: 'Descargar la app',
    },
    COMMON: {
      CONTINUE: 'Continuar',
      RETURN: 'Volver',
      CLOSE: 'Cerrar',
      FINISH: 'Finalizar',
    },
  },
} as const;
